import './faq.css'

function Faq() {
    return (
        <div className="faq">
            <h2 id='FAQ'>FAQS</h2>
            <div className="questions">
                <h2>What is WriteAI?</h2>
                 <p>WriteAI is an AI-powered website that generates written content, like emails, articles and essays. It's easy to use, fast, and produces high-quality, professional writing. Perfect for busy professionals, students, and content creators. Let WriteAI handle the writing, so you can focus on what matters.</p>
            </div>
            <div className="questions">
                <h2>How to Use</h2>
                <p>To use WriteAI, simply fill in the prompts provided and let our AI technology do the rest. If you want more personalized prompts, use the custom option and provide as much detail as possible. Our AI will use this information to generate the most tailored content possible.</p>
            </div>
            <div className="questions end">
                <h2>Copywrite</h2>
                <p>"All content generated by WriteAI is NOT copyrighted and can be used freely for personal or commercial use."</p>
            </div>
        </div>
    );
}

export default Faq;